// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeacherFilterSection{
    height: 10vh;
    width: 100%;
    padding: 1%;
    margin: 2% 0 2% 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.TeacherFilter{
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    border-radius: 2vh;
    background-color: #95dc98;
    padding: 1% 2% 1% 2%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); 
}
#TPteacherDropdown,#TPcourseDropdown{
    margin: 0 2% 0 2%;
    width: 40vw;
    padding: 1%;
    color: gray;
    border: 0;
}
.TP-Details{
    width: 100%;
    height: auto;
    padding: 1%;
    display: flex;
    flex-direction: row;
    align-self: center;
}
.TPDetail-LeftSection{
    width: 50%;
    float: left;
}
.TPDetail-RightSection{
    width: 50%;
}

.TP-MeetSection,.TP-CurrentSchedule,.TP-Availability,.TP-BankDetails{
    width: 90%;
    height: auto;
    padding: 1%;
    margin: 2% 0 2% 0;
    background-color: #e0f2e1;
    border-radius: 1vh;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); 
}
.TP-CurrentSchedule{
    width: 50%;
}
.TP-Availability{
    width: 50%;
}
.TP-BankDetails{
    width: 50%;
}

.TP-Education,.TP-Experience,.TP-CoursesSection{
    width: 90%;
    height: auto;
    padding: 1%;
    margin: 2% 0 2% 0;
    background-color: #e0f2e1;
    border-radius: 1vh;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); 
}
.TP-Label{
    margin-right:1%;
    font-size:15px;
    color:white;
    padding:1%;
    font-weight:bold;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/AdminActions/TeacherProfile.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,wCAAwC;AAC5C;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,WAAW;IACX,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB","sourcesContent":[".TeacherFilterSection{\n    height: 10vh;\n    width: 100%;\n    padding: 1%;\n    margin: 2% 0 2% 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.TeacherFilter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    border-radius: 2vh;\n    background-color: #95dc98;\n    padding: 1% 2% 1% 2%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); \n}\n#TPteacherDropdown,#TPcourseDropdown{\n    margin: 0 2% 0 2%;\n    width: 40vw;\n    padding: 1%;\n    color: gray;\n    border: 0;\n}\n.TP-Details{\n    width: 100%;\n    height: auto;\n    padding: 1%;\n    display: flex;\n    flex-direction: row;\n    align-self: center;\n}\n.TPDetail-LeftSection{\n    width: 50%;\n    float: left;\n}\n.TPDetail-RightSection{\n    width: 50%;\n}\n\n.TP-MeetSection,.TP-CurrentSchedule,.TP-Availability,.TP-BankDetails{\n    width: 90%;\n    height: auto;\n    padding: 1%;\n    margin: 2% 0 2% 0;\n    background-color: #e0f2e1;\n    border-radius: 1vh;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); \n}\n.TP-CurrentSchedule{\n    width: 50%;\n}\n.TP-Availability{\n    width: 50%;\n}\n.TP-BankDetails{\n    width: 50%;\n}\n\n.TP-Education,.TP-Experience,.TP-CoursesSection{\n    width: 90%;\n    height: auto;\n    padding: 1%;\n    margin: 2% 0 2% 0;\n    background-color: #e0f2e1;\n    border-radius: 1vh;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); \n}\n.TP-Label{\n    margin-right:1%;\n    font-size:15px;\n    color:white;\n    padding:1%;\n    font-weight:bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
